import React, { useState, useEffect } from "react";
import IconButton from "@material-ui/core/IconButton";

const SocialIcon = ({ content }) => {
  const [offsetTop, setOffsetTop] = useState(0);

  useEffect(() => {
    window.addEventListener("scroll", () => setOffsetTop(window.scrollY));
    return window.removeEventListener("scroll", () =>
      setOffsetTop(window.screenY)
    );
  }, [offsetTop]);

  let socialIconStyle =
    offsetTop < 250
      ? {
          opacity: 1 - offsetTop / 250,
        }
      : {
          display: "none",
        };
  return (
    <div className="content__social" style={socialIconStyle}>
      {content.map((social) => (
        <IconButton
          key={social.label}
          aria-label={social.label}
          rel="noopener noreferrer"
          href={social.href}
          target="_blank"
          className="text-white navIcon"
        >
          {<social.icon className="icon"></social.icon>}
        </IconButton>
      ))}
    </div>
  );
};

export default SocialIcon;
